import { render } from "./wall.vue?vue&type=template&id=cb944a6e&lang=pug"
import script from "./wall.vue?vue&type=script&lang=js"
export * from "./wall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__